export enum LocalStorageKey {
  TelegramLoginRedirectURI = 'telegramLoginRedirectURI',
  RefreshToken = 'refreshToken',
  AccessToken = 'accessToken',
}

export enum SessionStorageKey {}
